const PERSONAL_FIELDS = ['firstName', 'lastName', 'email', 'mobile'];
const hasOwn = (record, key) => Object.prototype.hasOwnProperty.call(record || {}, key);
const normalizeValue = value => (value == null ? '' : typeof value === 'string' ? value.trim() : value);
const isMissing = value => value == null || (typeof value === 'string' && value.trim() === '');

function normalizePersonalPatch(patch = {}) {
  return PERSONAL_FIELDS.reduce((result, field) => {
    if (hasOwn(patch, field)) result[field] = normalizeValue(patch[field]);
    return result;
  }, {});
}

function getMissingContact(person = {}) {
  return { missingEmail: isMissing(person.email), missingMobile: isMissing(person.mobile) };
}

function validatePersonalProfile(person = {}) {
  const { firstName, lastName, email, mobile } = normalizePersonalPatch(person);
  const errors = {};
  if (typeof firstName !== 'string' || !firstName) errors.firstName = 'Imię jest wymagane.';
  if (typeof lastName !== 'string' || !lastName) errors.lastName = 'Nazwisko jest wymagane.';
  if (!isMissing(email) && (typeof email !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@.]+$/.test(email))) {
    errors.email = 'Nieprawidłowy adres e-mail.';
  }
  if (!isMissing(mobile)) {
    if (typeof mobile !== 'string' || !/^\+?[0-9() -]+$/.test(mobile)) {
      errors.mobile = 'Nieprawidłowy numer telefonu.';
    } else if (mobile.replace(/\D/g, '').length < 6) {
      errors.mobile = 'Numer telefonu jest za krótki.';
    }
  }
  return errors;
}

function preparePersonalProfile(patch, existing = {}) {
  const person = { email: '', mobile: '', ...existing, ...normalizePersonalPatch(patch) };
  const errors = validatePersonalProfile(person);
  if (Object.keys(errors).length) {
    throw Object.assign(new Error(Object.values(errors).join(' ')), { statusCode: 400 });
  }
  return person;
}

module.exports = { normalizePersonalPatch, getMissingContact, validatePersonalProfile, preparePersonalProfile };
